import { Box, Card, Typography } from '@mui/material';
import { FC } from 'react';
import { DutyActivity } from '../../models/workday';
import { createBlockPrep } from './BlockPrep';
import { SxProps } from '@mui/system';

type Props = {
  da: DutyActivity;
  isOutPrep: boolean;
};

const classes: SxProps = {
  card: {
    border: 'none',
    boxShadow: 'none',
    backgroundColor: '#f5f5f5',
  },
  content: {
    textAlign: 'right',
    fontStyle: 'italic',
  },
};

export const BlockPrepCardContent: FC<Props> = ({ da, isOutPrep }) => {
  const blockPrep = createBlockPrep(da, isOutPrep);

  if (
    blockPrep.vehicleInfo === '' &&
    blockPrep.information === '' &&
    blockPrep.intro === ''
  )
    return null;

  return (
    <Box px={2} py={1}>
      {blockPrep.vehicleInfo !== '' && (
        <Typography sx={classes.content}>{blockPrep.vehicleInfo}</Typography>
      )}
      {blockPrep.information !== '' && (
        <Typography sx={classes.content}>{blockPrep.information}</Typography>
      )}
      {blockPrep.intro !== '' && (
        <Typography sx={classes.content}>{blockPrep.intro}</Typography>
      )}
    </Box>
  );
};

export const BlockPrepCard: FC = ({ children }) => {
  return (
    <Card sx={classes.card}>
      <Box>{children}</Box>
    </Card>
  );
};
